export default __webpack_public_path__ + "static/media/flag-ecuador.355f7358.svg";